import { backgroundCss } from 'common/utils/styleUtilsNew'
import { css, styled } from 'styled-components'

export interface WebsiteLayoutBodyWrapperProps {
  background: string | undefined
  backgroundImage: string
}

export const WebsiteLayoutBodyWrapper = styled.div<WebsiteLayoutBodyWrapperProps>`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  ${backgroundCss}
  ${p =>
    p.backgroundImage &&
    css`
      background-image: ${p.backgroundImage};
    `};
  

`
